import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgImprovedTeaAndCoffee32 = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 28,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 23v1H0v-1h28ZM20 0a1 1 0 0 1 .869 1.495L20.8 1.6 19 4v17H5v-3H3v-1h2v-1H2a1 1 0 0 1-.993-.883L1 15V4a1 1 0 0 1 .883-.993L2 3h3V0h15ZM6 20h12V3.667L19.998 1H6v19ZM25 9v3h3v1h-3v3h-1v-3.001L21 13v-1l3-.001V9h1ZM5 4H2v11h3V4Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgImprovedTeaAndCoffee32;